module.exports = __webpack_public_path__ + "img/previsualisation-gr.5e61301e.svg";